"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reactive_vue_1 = require("@formily/reactive-vue");
var vue_1 = require("@formily/vue");
var vue_demi_1 = require("vue-demi");
// @ts-ignore
var Import_vue_1 = __importDefault(require("./Import.vue"));
var formilyImport = (0, reactive_vue_1.observer)((0, vue_demi_1.defineComponent)({
    name: 'Export',
    props: ['value', 'tableData'],
    setup: function (curProps, _a) {
        var attrs = _a.attrs, emit = _a.emit;
        var field = (0, vue_1.useField)();
        return function () {
            var _a;
            return (0, vue_1.h)(Import_vue_1.default, {
                attrs: __assign(__assign(__assign({}, curProps), attrs), { tableData: (_a = field.value.componentProps.tableData) !== null && _a !== void 0 ? _a : [] }),
                on: {
                    change: function (val) {
                        emit('change', val);
                    },
                },
            }, {
                default: function () { return [curProps.value]; },
            });
        };
    },
}));
exports.default = formilyImport;
